import React from 'react';
import styles from './resend-otp.module.scss';
import { TertiaryButton } from '@workday/canvas-kit-react/button';
import { UNAUTH_FLOW } from '../error-page/error-page';
import { autoId, Tooltip, TooltipButton } from '@workday/upc-common';
import { ID_RESEND_OTP } from '../../autoIds';
import classNames from 'classnames';
import { TertiaryButtonLink } from '../../feature-auth/reset-password/tertiary-button-link';
import { useTranslation } from 'react-i18next';
import { ERROR_PATH } from '../../react-router-paths';
import { Flex } from '@workday/canvas-kit-react';

export const ID_RESEND_TOOLTIP = 'resend-tooltip';

interface ResendOTPProps {
    className?: string;
    isDisabled?: boolean;
    onResend: (e: React.MouseEvent) => void;
    otpType?: 'email' | 'phone';
    errorPath?: string;
}

export const ResendOTP = ({ isDisabled, onResend, otpType = 'phone', className, errorPath }: ResendOTPProps) => {
    const { t } = useTranslation('auth');
    return (
        <div className={classNames(styles.resendOTP, className)}>
            <TertiaryButton
                {...autoId(ID_RESEND_OTP)}
                className={styles.resendOTPButton}
                disabled={isDisabled}
                onClick={onResend}
                size='large'
                type='button'>
                {t('Resend.otpButton')}
            </TertiaryButton>
            {errorPath ? (
                <TertiaryButtonLink to={ERROR_PATH} context={UNAUTH_FLOW}>
                    {otpType === 'phone' ? t('ResendOTP.unableToAccessMobile') : t('ResendOTP.unableToAccessEmail')}
                </TertiaryButtonLink>
            ) : null}
            {otpType === 'email' && (
                <Flex alignItems='center' {...autoId(ID_RESEND_TOOLTIP)}>
                    <p className={styles.resendOtpMessage}>{t('Resend.emailOtp')}</p>
                    <Tooltip message={t('Resend.otpLearnWhyReason')}>
                        <TooltipButton>{t('Resend.otpLearnWhy')}</TooltipButton>
                    </Tooltip>
                </Flex>
            )}
        </div>
    );
};
